import React, {useState} from 'react'
import config from "../../../../config";
import DropdownSelect from "../../../../components-new/DropdownSelect";
import EN from '../../../../assets/flags/EN'
import HY from '../../../../assets/flags/HY'
import {updateLocale} from "../../../../services/user/api";
import {addNotification as addNotificationAction} from "../../../../services/notification/action";
import {updateUserData as updateUserDataAction} from "../../../../services/user/action";
import {connect} from "react-redux";
import LoadingComponent from "../../../../assets/LoadingComponent";

const LanguageSwitcher = ({user,updateUserData}) => {

    const [locale, setLocale] = useState(user.language);
    const [isLoading, setIsLoading] = useState(false);

    const iconMap = {
        hy:<HY height={18}/>,
        en:<EN height={18}/>
    }

    const handleChange = (val) => {
        if(val === locale || isLoading)return
        setIsLoading(true);
        updateLocale(val).then(res => {
            if(res){
                updateUserData(res)
                setLocale(val)
            }
        }).finally(()=>{
            setIsLoading(false);
        })
    };

    return (
        <DropdownSelect
            options={config.localesOptions}
            selectedValue={locale}
            onChange={handleChange}
            styles={{width: '100px'}}
            renderLabel={(val) => {
                    return (
                        <React.Fragment>
                            {
                                isLoading ?
                                    <div style={{width:'20px', height:'20px'}}>
                                        <LoadingComponent size={20}/>
                                    </div>

                                    :
                                <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                                    {iconMap[val]}
                                    <span>{val.toUpperCase()}</span>
                                </div>}
                        </React.Fragment>
                    )
                }
            }
        >
            {(option) =>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {iconMap[option.value]}
                    <span>{option.title}</span>
                </div>
            }
        </DropdownSelect>
    )
}


const mapDispatchToProps = {
    addNotification: addNotificationAction,
    updateUserData: updateUserDataAction,
};


export default connect(null, mapDispatchToProps)(LanguageSwitcher);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/header/LanguageSwitcher.jsx